import DashboardField from './DashboardField'

export default function DashboardTargetRecord ({ dashboardTargetId }) {
  const act = useAct();
  const dashboardTarget = useSel(s => s.dashboardTargets.entities[dashboardTargetId]);
  const dashboardFields = useSel(s => _.orderBy(s.dashboard.dashboardFields, 'digitOrder', 'asc'));

  return (
    <div className='dashboard-record'>
      {dashboardFields.map((field, index) => {
        return (
          <div className='dashboard-record-field'>
            <span className='dashboard-record-field-name'>{field.name}</span>
            <span className='dashboard-record-field-value'>
              <DashboardField key={field.id} field={field} dashboardTarget={dashboardTarget} className='dont-grow' />
            </span>
          </div>
        )
      }) }
    </div>
  )
}
